import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ADMIN_TOKEN_KEY = "rf_admin_token";

api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } catch { /* ignore */ }
  return config;
});

export const CATEGORIES = ["All", "Grant", "Fellowship", "Residency", "Open Call", "Job"];
export const DISCIPLINES = ["All", "Visual Arts", "Performing Arts", "Literary Arts", "Film & Media", "Interdisciplinary"];
export const FOCUS = ["All", "Women", "LGBTQ+", "BIPOC"];
